<template>
  <div class="sub-header-tab">
    <swiper :options="swiperOption">
      <swiper-slide
        class="item"
        :class="{ 'active' : selectedId === parseInt(item.id) }"
        @click.native="selected(item)"
        v-for="(item, index) in items"
        :key="index"
      >
        {{ getTabName(item) }}
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev">
        <img src="/static/images/ic-arrow-left-menu.svg" alt="prev">
      </div>
      <div class="swiper-button-next" slot="button-next">
        <img src="/static/images/ic-arrow-right-menu.svg" alt="next">
      </div>
    </swiper>
  </div>
</template>

<script>
  export default {
    name: 'sub-header-tab',
    props: {
      items: {
        type: Array,
        default: [],
      },
      selectedId: {
        type: Number,
        default: 0,
      },
      isStaticTab: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        swiperOption: {
          slidesPerView: 8,
          spaceBetween: 30,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            1024: {
              slidesPerView: 8,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 6,
              spaceBetween: 0,
            },
            640: {
              slidesPerView: 4,
              spaceBetween: 0,
            },
            320: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
          },
        },
      };
    },

    methods: {
      selected(item) {
        this.$emit('selectedTab', item);
      },

      getTabName(item) {
        if (!this.isStaticTab) {
          return item.id === 0 ? this.$t(item.name) : item.name;
        }

        return this.$t(item.name);
      },
    },
  };
</script>

<style lang="scss" scoped>

  %swiper-button-shared {
    color: rgba(0, 0, 0, 0.4);
    height: 32px;
    width: 32px;
    background-image: none;
    margin-top: -16px;

    img {
      height: 32px;
      width: 32px;
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .swiper-container {
    padding: 0px 40px 0px 40px;
  }

  .sub-header-tab {
    max-width: 946px;
    margin: 26px auto 0px;
    overflow-x: auto;
    white-space: nowrap;

    .swiper-button-next {
      right: 0;
      @extend %swiper-button-shared;
    }

    .swiper-button-prev {
      left: 0;
      @extend %swiper-button-shared;
    }

    .item {
      text-align: center;
      display: inline-block;
      padding: 4px 0px 4px 0px;
      font-weight: bold;
      cursor: pointer;
      color: rgba(0, 0, 0, 0.4);
      font-size: 14px;

      &:hover {
        color: #00C896;
      }

      &.active {
        color: #00C896;
        border-bottom: 2px solid #00C896;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// SubHeaderTab.vue?fa564610